import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

function AdminSideBar() {

  const {user} = useSelector(state => state.auth)

  return (
    <>
      {user?.isAdmin ? (
        <aside className="admin-sidebar">
          <h1 className="admin-logo"></h1>
          <nav className="admin-nav">
            <Link to="/admin-dashboard/users-list" className="admin-nav-item">
              Users
            </Link>
            <Link to="/admin-dashboard/reports" className="admin-nav-item">
              Attendance Reports
            </Link>
            <Link to="/admin-dashboard/daily-updates-today" className="admin-nav-item">
  Daily updates Reports
</Link>
            <Link to="/admin-dashboard/settings" className="admin-nav-item">
              Settings
            </Link>
            <Link to={`/users/profile/${user?._id}`} className="admin-nav-item">
              My Profile
            </Link>
           
        
          </nav>
        </aside>
      ) : (
        <aside className="admin-sidebar">
          <h1 className="admin-logo"></h1>
          <nav className="admin-nav">
            <Link to={`/users/profile/${user?._id}`} className="admin-nav-item">
              My Profile
            </Link>
            <Link to="/attendance" className="admin-nav-item">
              Attendance
            </Link>
            <Link to="/admin-dashboard/reports" className="admin-nav-item">
              Attendance Report
            </Link>
            <Link to="/daily-updates" className="admin-nav-item">
               Daily Update
            </Link>
          </nav>
        </aside>
      )}
    </>
  )
}

export default AdminSideBar
